<template>
  <button
    @click="advance"
    class="btn"
    :class="{ next: type === 'next', back: type !== 'next' }"
    :disabled="isDisabled"
  >
    <div
      class="spinner-border spinner-border-sm mr-2 text-primary"
      v-if="loading"
    ></div>
    {{ loading ? "Processing..." : text }}
  </button>
</template>

<script>
export default {
  name: "BottomButton",
  props: {
    loading: Boolean,
    text: String,
    type: String,
    step: Number,
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currStep: this.step,
    };
  },
  methods: {
    advance() {
      this.$emit("advance", this.currStep++);
    },
  },
};
</script>

<style scoped>
.text-primary {
  color: #009fdb !important;
}
.spinner-border-sm {
  width: 1.5rem;
  height: 1.5rem;
  border-width: 0.18rem;
}
button {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border: 2px solid transparent;
  border-radius: 2em;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  text-align: center;
  line-height: 1;
  outline: 1px solid transparent;
  text-decoration: none !important;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 0.9rem;
  font-weight: 600;
  min-width: 100px;
  padding: 14px 32px;
  vertical-align: bottom;
  letter-spacing: 0.03rem;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

button div {
  margin: -8px 0px;
}

button:disabled {
  background: #f8fafb !important; /* Grey 200 */
  color: #878c94; /* Grey 500 */
}
button:disabled:hover {
  background: #f8fafb !important; /* Grey 200 */
  color: #878c94; /* Grey 500 */
}

.next {
  background: #0057b8; /* Cobalt 600 */
  color: #f2fafd;
}
.next:hover {
  background: #007ae2; /* Cobalt 400 */
  color: #f2fafd;
}

.back {
  background-color: rgba(0, 0, 0, 0);
  border: 2px solid #0057b8; /* Cobalt 600 */
  color: #0057b8; /* Cobalt 600 */
  margin: 0 0.5rem 0 0;
}

.back:hover {
  background-color: #007ae2; /* Cobalt 400 */
  border: 2px solid #007ae2; /* Cobalt 400 */
  color: #f8fafb; /* Grey 100 */
  margin: 0 0.5rem 0 0;
}

/* smaller than iPad screens */
@media (max-width: 600px) and (max-height: 960px),
  (max-width: 960px) and (max-height: 600px) {
  .next {
    width: 100%;
  }

  .back {
    width: 100%;
    margin: 0 0 0.5rem 0;
  }
}
</style>
